import React, { Component } from 'react'
import Slide from '../Globals/Slide/slide'
import BigCalendar from 'react-big-calendar';
import {connect} from 'react-redux';
import Modal from 'react-modal';
import Alert from 'react-s-alert';
import firebase from 'firebase';
import InfiniteCalendar, { Calendar, defaultMultipleDateInterpolation, withMultipleDates } from 'react-infinite-calendar';
import 'react-infinite-calendar/styles.css';
import './estilo.css'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import 'moment/locale/es';
import CargarEmple from './cargaEmple';
import store from '../../store';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import moment from 'moment';
//use material theme
import 'react-times/css/material/default.css';
import Select from 'react-select';
import icon from '../../img/Group.png'
import { Pulse } from 'react-preloading-component';
import copyright from '../../img/copyright-gray.png';

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment))
const format = 'h:mm a';

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		transform: 'translate(-50%, -50%)',
		width: '85%',
		height: '500px',

	}
};
const customStylesS = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		transform: 'translate(-50%, -50%)',
		width: '700px',
		height: '350px',

	}
};
const customStylesM = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		transform: 'translate(-50%, -50%)',
		width: '80%',
		height: '550px',

	}
};

var today = new Date();
class NuevoViaje extends Component {
	constructor(props) {
		super(props);
		this.state = {
			template: false, eventos: [], seleccionados: [], vuelo: '', isGuardando: true, empresas: [], empresa: '', 
			tipo: 'tcs', actual: '', empresaUID: '', isActive: false, isActiveSeleccion: false, userKey: '',
			isActiveCarga: false, isActiveModificar: false, edt2: '', viajes: [], viajesD: [], select: true,
			isElimi: false, isGuar: false, actualV: [], generales: [], justiCanc: '', seleElim: [],
			pasado: 0, empleadosEmpresa: [], justiAdd: '', empleS: '', hour: '12', minute: '00',
			hour2: '12', minute2: '00', value: 'pilotos', bases: [], baseI: '', baseF: '', basesF: [],
			HI: '', inicio: '', destino: '', estado: '', rutas: [], rutaA: '', now: moment(), now2: moment(),
			rutasS: [], programacionDiaKey: [], pasajeros: [], isLoading: true, prograID: '', prograDiaId: '',
			actual:[],guardados:[],busqueda:[],centroCosto:[],centro:'', flotas: [], flota:[], entrenamiento:'inicial'
		};
		this.AlertaContenido = ({
			id,
			classNames,
			styles,
			message,
			customFields,
			handleClose,
		}) => {
			const handleConfirm = () => {
				this.almacenarCambios()
				Alert.close(id);
				this.setState({
					template: false
				})
			}
			return (
				<div className={classNames} id={id} style={styles}>
					<div className='s-alert-box-inner'>
						{message}
					</div>
					<br />
					<br />
					<button className="customButton btn btn-success btn-alerts btn-m" onClick={handleConfirm.bind(this)}>Confirmar</button>
					<button className="customButton btn btn-default btn-alerts btn-m-r" onClick={this.handleClickClose}>Cancelar</button>
					<span className='s-alert-close' onClick={handleClose}></span>
				</div>
			);
		}
		// this.empresasUID = this.empresasUID.bind(this);
		this.getUser = this.getUser.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleChangeE = this.handleChangeE.bind(this);
		this.cargar = this.cargar.bind(this);
		this.modificar = this.modificar.bind(this);
		this.isELi = this.isELi.bind(this);
		this.justi = this.justi.bind(this);
		this.cancela = this.cancela.bind(this);
		this.marcar = this.marcar.bind(this);
		this.nuevoPas = this.nuevoPas.bind(this);
		this.addEmple = this.addEmple.bind(this);
		this.obtenerEmpresas = this.obtenerEmpresas.bind(this);
		this.getEmpresas = this.getEmpresas.bind(this);
		
	}

	ocultarMenu() {
		store.dispatch({
			type: 'STATE_MOSTRAR',
			mostrar: 'noMostrar'
		})
	}

	getUser() {
		let {empresaUID} = this.state;
		empresaUID = this.props.EmpresaUID;
		this.setState({empresaUID});
		this.obtenerEmpresas(empresaUID);
		
	}

	selectTipoViaje(filtro) {
		this.setState({ filtro });
	}

	getEmpresas() {
		firebase.database().ref("Empresa").once("value", snap => {
			let oempresas = [];
			snap.forEach(element => {
				oempresas.push({
					value: element.key,
					label: element.val().codigo_empresa
				});
			});
			this.setState({empresas: oempresas});
		});
	}

	obtenerEmpresas(empresaUID) {
		let self = this;
		
		let oempresas = [];
		let empresaU = '';
		firebase.database().ref('Empresa').once('value', snap => {
			snap.forEach(element => {
				
				if (empresaUID === element.key) {
				
					oempresas.push({
						value: element.key,
						label: element.val().codigo_empresa
					});
				}
				
			});
		}).then(snap =>{
			let key = this.props.EmpresaUID;

			self.setState({userKey: key, empresas: oempresas});
			empresaU = self.getEmpresa();
			
			self.setState({ empresaUID: empresaU});
			let nempresa = self.getNombreEmpresa();
			self.setState({ empresa: nempresa });
			firebase.database().ref('AjustesEmpresa/' + self.state.empresaUID + '/tiposV').once('value').then(snap => {
				let data = snap.val();
				self.setState({ viajes: data })
			});
			
			self.getBases();
			self.getRutas(empresaU);
			self.getClientes(empresaU);
			self.getFlotas();
		});
	}

	changeEmpresa = (event) => {
		/* Refresco de eventos */
		this.setState({empresaUID: event.value, empresa: event, isLoading:true});
		firebase.database().ref('AjustesEmpresa/' + event.value + '/tiposV').once('value').then(snap => {
			let data = snap.val();
			this.setState({ viajes: data })
		});
		this.getBases();
		this.getRutas(event.value);
		this.getClientes(event.value);
		this.getFlotas();
	}

	getNombreEmpresa() {
		let {empresas, empresaUID} = this.state;
		let e = empresas.find(v => v.value == empresaUID);
		return e;
	}

	getEmpresa() {
		let {empresas, userKey} = this.state;
		let e;
		function findValue(empresa) {
			return empresa.value === userKey;
		}
		try {
			e = empresas.find(findValue).value;
			this.setState({empresa: e.codigo_empresa});
		}catch(error) {
			e = empresas[0].value;
			this.setState({empresa: empresas[0].codigo_empresa});
		}
		return e;
	}

	getRutas(empresaUID) {
		firebase.database().ref('Rutas').once('value', snap => {
			let rutas = [];
			let rutasS = [];
			let o = [];
			snap.forEach(element => {
				let obje = element.val();
				obje.key = element.key;
				o = { label: obje.nombRuta, value: element.key };
				rutas.push(o);
				rutasS.push(obje);
			});
			this.setState({ rutas, rutasS });
			this.getProgra(empresaUID);
		})
	}

	componentDidMount = () => {
		this.getUser();
	}

	getClientes = (empresaUID) => {
		
		firebase.database().ref().child('Clientes').orderByChild('socio').equalTo(empresaUID).once('value').then(snap => {
			let empleadosEmpresa = [];
			let pasajeros = [];
			snap.forEach(element => {
				let data = element.val();
				data.key = element.key;
				let emple = { value: element.key, label: data.nombre + ' ' + data.apellido };
				empleadosEmpresa.push(emple);
				pasajeros.push(emple);
			});
			let centroCosto = [];
			firebase.database().ref().child('CentroCosto').orderByChild('empresa').equalTo(empresaUID).once('value').then(snapC => {
				snapC.forEach(element => {
					let data = element.val();
					let emple = { value: element.key, label: data.codigo };
					centroCosto.push(emple);
				});
			})
			this.setState({ empleadosEmpresa, isLoading: false, pasajeros, centroCosto })
		})
	}

	selectValidate = () => {
		this.setState({entrenamiento:'', flota:[]})
	}

	getProgra = (empresaUID) => {
		firebase.database().ref().child('Programacion').orderByChild('solicitante').equalTo(empresaUID).once('value', snap => {
			let arrayT = []
			snap.forEach((element) => {
				let obte = element.val();
				let hora = obte.horaReco.split(":");
				let encuentraColor = this.state.rutasS.find(rutas => {
					return obte.ruta === rutas.key;
				})
				if (Array.isArray(obte.frecuencia)) {
					obte.frecuencia.map(f => {
						let fecha = new Date(f);
						arrayT.push({
							id: element.key,
							title: obte.vuelo,
							start: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), hora[0], hora[1]),
							end: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), hora[0], hora[1]),
							desc: obte.tipo,
						})
					});
				}
			});
			this.setState({ eventos: arrayT });
		})
	}

	getBases = () => {
		firebase.database().ref('Bases').once('value').then(snap => {
			let bases = [];
			snap.forEach(element => {
				let data = element.val();
				data.key = element.key;
				bases.push(data);
			});
			this.setState({ bases });
		})
	}

	getProgramacionDatos = (actualV, edt2) => {
		let pasajeros = [];

		firebase.database().ref().child('Programacion/' + actualV.key + '/programacionDia').once('value').then(snap => {

			let value = snap.val();
			value.map(element => {
				firebase.database().ref('ProgramacionDia/' + element).once('value').then(snap2 => {
					let val = snap2.val();
					let fechaR = new Date(val.fecha);
					let fechaS = new Date(edt2.start);
					let formateada = fechaS.getFullYear() + '/' + (fechaS.getMonth() + 1) + '/' + fechaS.getDate();
					let fechaActu = new Date(formateada);
					if (fechaR.getTime() === fechaActu.getTime()) {
						pasajeros.push(element);
					}
				})
			})
			this.setState({ programacionDiaKey: pasajeros });

		})

	}

	validar = (edt2) => {
		let { empleadosEmpresa, pasajeros } = this.state;
		firebase.database().ref().child('ProgramacionDia').orderByChild('programacion').equalTo(edt2.id).once('value', snap => {
			if(snap.val() !== null)
			{
				snap.forEach(element => {
					let data = element.val();
					let fechaSeleccionada = new Date(edt2.start);
					let fechaSeleccionadaBuena = new Date(fechaSeleccionada.getFullYear() + '/' + (fechaSeleccionada.getMonth() + 1) + '/' + fechaSeleccionada.getDate());
					let fechaRegistro = new Date(data.fecha);
					if (fechaSeleccionadaBuena.getTime() === fechaRegistro.getTime()) {
						if(data.pasajeros !== undefined){
							this.setState({ viajesD: data.pasajeros, prograDiaId: element.key, actual:data});					
						}	
						else{
							this.setState({viajesD:[], empleadosEmpresa:pasajeros, prograDiaId: element.key, actual:data})
						}
					}
				});
				this.setState({isActiveSeleccion: true, prograID: edt2, isGuardando:false, busqueda:snap})
			}
			else{
				this.setState({ isActiveSeleccion: true, prograID: edt2, isGuardando:false,})
			}
		})

	}

	toggleActive = () => {
		this.setState({ isActive: false })
		this.setState({now: moment(),now2: moment()})
	}
	toggleActiveS = () => {
		this.setState({ isActiveSeleccion: false })
	}
	toggleActiveC = () => {
		this.setState({ isActiveCarga: false })
	}
	toggleActiveM = () => {
		this.setState({ isActiveModificar: false })
	}

	nuevaRese = (datos) => {
		let objetos = []
		datos.slots.forEach(element => {
			objetos.push(element);
		});
		this.setState({
			seleccionados: objetos, isActive: true, isGuardando: true, vuelo: '', ruta: '', edt: '00:00',
			hour: '12', minute: '00', hour2: '12', minute2: '00'
		})
	}

	tipo = (event, start, end, isSelected) => {
		if (event.desc === 'pilotos') {
			let newStyle = {}; newStyle.backgroundColor = "#512B39"
			return { class: "", style: newStyle };
		}
		if (event.desc === 'pilotossap') {
			let newStyle = {}; newStyle.backgroundColor = "#A0A2A4"
			return { class: "", style: newStyle };
		}
		if (event.desc === 'tcs') {
			let newStyle = {}; newStyle.backgroundColor = "#DF2525"
			return { class: "", style: newStyle };
		}
		if (event.desc === 'tcssap') {
			let newStyle = {}; newStyle.backgroundColor = "#EC7536"
			return { class: "", style: newStyle };
		}
		if (event.desc === 'persTierr') {
			let newStyle = {}; newStyle.backgroundColor = "#ff9900"
			return { class: "", style: newStyle };
		}
	}

	selecion = (datos) => {
		let fecha = datos.toString();
		let found = this.state.seleccionados.find(element => {
			return element.toString() == fecha.toString();
		});
		if (found === undefined) {

			this.setState({ seleccionados: [...this.state.seleccionados, fecha] });
		}
		else {

			let obje = this.state.seleccionados;
			let index = obje.indexOf(found);
			obje.splice(index, 1);
			this.setState({ seleccionados: [...obje] })
		}

	}

	guardarReserva = (event) => {
		this.setState({
			template: true
		})
		const customerName = 'Bacer';
		Alert.success('¿Deseas confirmar los cambios?', {
			position: 'top-right',
			timeout: 'none',
			customFields: {
				customerName: customerName
			}
		});

		event.preventDefault();
	}

	getFlotas(){
        firebase.database().ref('Flotas').once('value').then(snap => {
            let flotas = [];
            snap.forEach(element => {
				let data = element.val();

                flotas.push({ label: data.flota, value: element.key });
            })
			this.setState({ flotas });

        })
    }

	almacenarCambios = () => {
		let { seleccionados, guardados, busqueda, centro, flota, entrenamiento, select } = this.state;
		let dato = [];
		seleccionados.forEach(element => {
			dato.push({ valor: element });
		});

		let usua = this.state.empresaUID;
		let ruta = this.state.rutaA.value;
		let tipo = this.state.value;
		let centroC = this.state.centro.value;
		flota = flota.value;
		if (ruta !== undefined) {
			if (centroC !== undefined) {
				if (flota !== undefined) {
					if(entrenamiento !== undefined){
						//Guardar
						if (this.state.isGuardando === true) {
							var hola = firebase.database().ref().child('Programacion').push({
								tipo,
								estado: true,
								solicitante: usua,
								horaReco: this.state.hour + ':' + this.state.minute,
								horaAero: this.state.hour2 + ':' + this.state.minute2,
								vuelo: this.vuelo.value,
								frecuencia: '',
								ruta,
								centroC,
								flota:select?flota:'',
								entrenamiento:select?entrenamiento:''
							});
							var messageRef = firebase.database().ref("Programacion/" + hola.key + "/frecuencia/");
							let v = [];
							let pD = {
								conductor: '',
								estado: 'Pendiente',
								horaInicio: this.state.hour + ':' + this.state.minute,
								horaLlegada: this.state.hour2 + ':' + this.state.minute2,
								programacion: hola.key,
								puntoA: 0,
								ruta,
								vehiculo: ''
							}
							let arreglo = [];

							for (let i = 0; i < dato.length; i++) {
								v = [...v, dato[i].valor.toString()];
								let ref = firebase.database().ref("ProgramacionDia").push({ ...pD, fecha: dato[i].valor.toString(), centroC:centro.value });
								arreglo.push(ref.key);
							}

							firebase.database().ref().child('Programacion').child(hola.key).update({ programacionDia: arreglo });

							messageRef.set(v);
							this.setState({now: moment(),now2: moment()})
							Alert.success('Datos Guardados', {
								effect: 'genie',
								position: 'bottom-right',
								timeout: 2000
							});
						}
						//Modificar
						else {
							let { actual } = this.state;
							let nuevos = [];
							seleccionados.forEach(element => {
								if(guardados.includes(element)){
								}else{
									firebase.database().ref().child('ProgramacionDia').push({
										conductor: '',
										estado: 'Pendiente',
										horaInicio: this.state.hour + ':' + this.state.minute,
										horaLlegada: this.state.hour2 + ':' + this.state.minute2,
										programacion: actual.programacion,
										fecha:element.toString(),
										puntoA: 0,
										ruta,
										vehiculo: '',
									})
									
								}
							});
							
							guardados.forEach(element => {
								if(seleccionados.includes(element)){
									busqueda.forEach(elementB => {
										let data = elementB.val();
										let fechaSeleccionada = new Date(element);
										let fechaSeleccionadaBuena = new Date(fechaSeleccionada.getFullYear() + '/' + (fechaSeleccionada.getMonth() + 1) + '/' + fechaSeleccionada.getDate());
										let fechaRegistro = new Date(data.fecha);
										if (fechaSeleccionadaBuena.getTime() === fechaRegistro.getTime()) {
											firebase.database().ref().child('ProgramacionDia/'+elementB.key).update({
												estado:'Pendiente',
												vehiculo:'',
												conductor:'',
												horaInicio: this.state.hour + ':' + this.state.minute,
												horaLlegada: this.state.hour2 + ':' + this.state.minute2,
												programacion: actual.programacion,
												fecha:element.toString(),
												puntoA: 0,
												ruta,
											})
										}
										
									});
								}else{
									busqueda.forEach(elementB => {
										let data = elementB.val();
										let fechaSeleccionada = new Date(element);
										let fechaSeleccionadaBuena = new Date(fechaSeleccionada.getFullYear() + '/' + (fechaSeleccionada.getMonth() + 1) + '/' + fechaSeleccionada.getDate());
										let fechaRegistro = new Date(data.fecha);
										if (fechaSeleccionadaBuena.getTime() === fechaRegistro.getTime()) {
											firebase.database().ref().child('ProgramacionDia/'+elementB.key).update({
												estado:'Inactivo'
											})
											if(data.conductor!== ''){
												firebase.database().ref().child('Empleados/'+data.conductor).update({
													viajeAsignado:false,
													espera:false
												})
											}
											if(data.vehiculo!== ''){
												firebase.database().ref().child('Vehiculos/'+data.vehiculo).update({
													estado:'Disponible',
													viajeAsignado:false
												})
											}
										}
									});
									
								}
							});
							let { prograID } = this.state;
							
							firebase.database().ref().child('Programacion/' + prograID.id).update({
								tipo,
								horaReco: this.state.hour + ':' + this.state.minute,
								horaAero: this.state.hour2 + ':' + this.state.minute2,
								vuelo: this.vuelo.value,
								frecuencia: '',
								ruta,
								frecuencia:seleccionados,
								centroC,
								flota:select?flota:'',
								entrenamiento:select?entrenamiento:''
							});
							this.setState({rutaA:[], now: moment(),now2: moment()});
							Alert.success('Datos Modificados', {
								effect: 'genie',
								position: 'bottom-right',
								timeout: 2000
							});
						}

						this.toggleActive();
					}
					else {
						Alert.warning('Seleccione entrenamiento de pilotos para este viaje', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
					}
					
				}
				else {
					Alert.warning('Seleccione flotas de pilotos para este viaje', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
				}
			}
			else {
				Alert.warning('Seleccione centros de costos para este viaje', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
			}
			
		}
		else {
			Alert.warning('Seleccione la ruta a programar para este viaje', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
		}
	}

	handleChange(event) {
		this.setState({ entrenamiento: event.target.value });
	}

	handleChangeE = (event) => {
		if (event.target.value === 'pilotossap' || event.target.value === 'pilotos') {
			this.setState({select:true});
			if (this.state.entrenamiento === '') {
				this.setState({entrenamiento:'inicial'});	
			}
		}
		else{
			this.setState({select:false});
			this.selectValidate();
			
		}
		this.setState({ value: event.target.value });
	}

	cargar() {
		this.setState({ isActiveCarga: true, isActiveSeleccion: false })
	}

	modificar() {
		this.setState({ isActiveSeleccion: false, isActiveModificar: true })
	}
	isELi() {
		this.setState({ isElimi: !this.state.isElimi, isGuar: false })
	}

	replanificar = () => {
		let { prograID, rutas, centroCosto, flota } = this.state;
		firebase.database().ref('Programacion/' + prograID.id).once('value', snap => {
			let seleccionados = [];
			let guardados = [];
			let obejetos = snap.val();
			if (obejetos !== undefined) {
				obejetos.frecuencia.forEach(element => {
					seleccionados.push(element);
					guardados.push(element)
				});
				let vuelo = obejetos.vuelo;
				let	rutaA = rutas.find(x => obejetos.ruta === x.value);
				let centro = centroCosto.find(x => obejetos.centroC === x.value);
				let time = obejetos.horaReco.split(':');
				let time2 = obejetos.horaAero.split(':');
				let now =  moment().hour(Number(time[0])).minute(Number(time[1]))
				let now2 =  moment().hour(Number(time2[0])).minute(Number(time2[1]))
				let value = obejetos.tipo;
				let hour = Number(time[0])
				let minute = Number(time[1])
				let hour2 = Number(time2[0])
				let minute2 = Number(time2[1])
				let flotaD = obejetos.flota;
				let entrenamiento = obejetos.entrenamiento;
				
				if (value === 'pilotossap' || value === 'pilotos') {
					
					this.setState({select:true});
					firebase.database().ref('Flotas/'+flotaD).once('value').then(data => {
						let element = data.val();
						if (element !== null && element !== undefined) {
							this.setState({flota:{label: element.flota, value: flotaD}});	
						}
						
					})
					
				}
				else{
					this.setState({select:false});
					this.selectValidate();
					
				}
				
				this.setState({ seleccionados, isActiveSeleccion: false, isActive: true,vuelo, 
					rutaA, now,now2, guardados, centro, value, hour, minute, hour2, minute2, entrenamiento })
			}
			
		})

	}


	justi = (data) => {
		this.setState({ justiCanc: data.target.value });
	}
	justiA = (data) => {
		this.setState({ justiAdd: data.target.value });
	}

	cancela = () => {
		let { seleElim, justiCanc } = this.state;
		if (seleElim.length === 0) {
			Alert.warning('Seleccione un empleado al cual cancelar el viaje', { effect: 'genie', position: 'bottom-right', timeout: 2000 });
		}
		else {
			if (justiCanc === '') {
				Alert.warning('Favor ingresar el motivo por el cual se esta cancelando el viaje', { effect: 'genie', position: 'bottom-right', timeout: 2000 });
			}
			else {
				firebase.database().ref('AsignacionViajes').orderByChild('prograP').equalTo(seleElim.np).once('value').then(data => {
					let obje = data.val();
					if (obje === null) {
						firebase.database().ref().child('ProgramacionDia/' + seleElim.pd).update({ estado: 'Cancelado', motiCanc: justiCanc });
						Alert.success('El viaje ha sido cancelado', {
							effect: 'genie',
							position: 'bottom-right',
							timeout: 2000
						});
					}
					else {
						Alert.warning('eliminar pasajero operacion no permitida, debido a que el viaje ah sido asigando', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
					}
				})
				this.setState({ justiCanc: '', isElimi: false })
			}
		}
	}

	marcar = (seleElim, index) => {
		if (document.getElementById(index).classList.contains('selecccion')) {
			document.getElementById(index).classList.toggle('selecccion');
			document.getElementById(index).classList.add('normalEm');
			this.setState({ seleElim: [] });
		}
		else {
			this.setState({ seleElim });
			document.getElementById(index).classList.toggle('normalEm');
			document.getElementById(index).classList.add('selecccion');
		}
	}

	nuevoPas() {
		this.setState({ isGuar: !this.state.isGuar, isElimi: false })
	}

	addEmple() {
		let { justiAdd, empleS, prograDiaId, viajesD } = this.state;
		if (justiAdd !== '') {
			if (empleS !== '') {
				let pasajeros = [];
				empleS.forEach(elementE => {
					let pasa = {
						codigo: elementE.value,
						horaLlegada: '',
						horaSubida: '',
						horaTimbre: '',
						nombre: elementE.label,
						subio: false,
					};
					pasajeros.push(pasa)
					viajesD.splice(viajesD.length, 0,  pasa);
					firebase.database().ref('Clientes').child(elementE.value).once('value').then(snap => {
						let s = snap.val();
						let viajes = s.Viajes;
						firebase.database().ref('Clientes').child(elementE.value).update({ Viajes: [ ...viajes, prograDiaId ] });
					});
				});

				if(viajesD.length === 0){
					firebase.database().ref().child('ProgramacionDia/' + prograDiaId).update({
						pasajeros
					})
				}else{
					firebase.database().ref().child('ProgramacionDia/' + prograDiaId).update({
						pasajeros:viajesD
					})
				}
				Alert.success('Su procesos ha sido realizado', {
					effect: 'genie',
					position: 'bottom-right',
					timeout: 1000
				});
				this.setState({ isGuar: false })
			}
			else {
				Alert.warning('Seleccione un empleado a añadir', { effect: 'genie', position: 'bottom-right', timeout: 2000 });
			}
		}
		else {
			Alert.warning('Favor ingresar el motivo por el cual se esta añadiendo el pasajero', { effect: 'genie', position: 'bottom-right', timeout: 2000 });
		}
	}

	addEmpleS = (event) => {
		this.setState({ empleS: event })
	}

	onTimeChange(options) {
		let hora = moment(options, "hmm").format("HH:mm")
		let data = hora.split(':');
		this.setState({ hour: data[0], minute: data[1], now: options.format('HH:mm:ss') });
	}

	onTimeChange2(options) {
		let hora = moment(options, "hmm").format("HH:mm")
		let data = hora.split(':');
		this.setState({ hour2: data[0], minute2: data[1], now2: options.format('HH:mm:ss') });
	}

	selectRuta(rutaA) {
		this.setState({ rutaA });
	}
	selectCentro(centro){
		this.setState({ centro });
	}

	selectFlota(flota){
		this.setState({ flota });
	}

	render() {
		let { eventos, seleccionados, actualV, generales, isGuar, empleadosEmpresa, estado, edt2, rutaA, rutas, now, now2,
			isLoading, centroCosto,centro, flotas, flota, select, entrenamiento, empresa, empresas, empresaUID } = this.state;
			
		if (isLoading !== true) {
			return (
				<div onClick={this.ocultarMenu}>
						<div className="container">
							<div className="row justify-content-sm-end">
								<div className="col-sm-1 align-self-end">
									<label>Empresa:</label>
								</div>
								<div className="col-sm-4">
									<Select value={empresa} className="Select-menu-outer" onChange={this.changeEmpresa} placeholder="Seleccione una empresa" options={empresas}></Select>
								</div>
							</div>
						</div>
					<div style={{ height: 600, margin: 30 }}>
						{this.state.template ? <Alert timeout='none' stack={{ limit: 1 }} contentTemplate={this.AlertaContenido} /> : <Alert stack={{ limit: 1 }} html={true} />}
						<BigCalendar
							selectable popup events={eventos} step={20} showMultiDayTimes
							defaultDate={new Date()} culture={'es'}
							eventPropGetter={this.tipo}
							messages={{ 'today': "Hoy", "previous": 'Anterior', "next": "Siguiente", "month": "Mes", "week": "Semana", "day": "Dia", "agenda": "Agenda" }}
						/>
						<div className="row" >
							<div className="col-sm-12">
								<div className="row">
									{this.state.viajes ? (this.state.viajes.map(snap => {
										return (
											<div className="col-sm-3 bordeInte borde">
												<div className="row">
													<div className="col-sm-11 margenI cuadro" style={{ backgroundColor: snap.color }}></div>
													<div className="col-sm-11 bordeInte2"><span style={{textAlign:'justify'}}>{snap.data}</span></div>
												</div>
											</div>
										)})) : (false)
									}
								</div>
							</div>
							<div className="col-sm-9"></div>
						</div>
						<Modal isOpen={this.state.isActive} onRequestClose={this.toggleActive} style={customStyles}>
							<div className="row">
								<div className="col-12 col-md-5">
									<InfiniteCalendar width={"100%"} height={300}
										locale={{
											locale: require('date-fns/locale/es'), headerFormat: 'dddd, D MMM',
											weekdays: ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"],
											blank: 'Nada seleccionado', todayLabel: { long: 'Ahora', short: 'Ahora' }
										}}
										Component={withMultipleDates(Calendar)} selected={seleccionados}
										interpolateSelection={defaultMultipleDateInterpolation} onSelect={this.selecion}
										autoFocus={false}
									/>
								</div>
								<div className="col-12 col-md-7">
									<h4 className="title-bold">Planificación de viajes</h4>
									<form method="POST" action="" onSubmit={this.guardarReserva} >
										<div className="form-group col-md-5">
											<div className="btn-group form-mar-top" role="group">
												<button type="button" className="btn btn-small-aqua">Viaje</button>
											</div>
										</div>
										<div className="form-row">
											<div className="form-group col-md-6">
											<label className="label-bold" htmlFor="Viaje" >Viaje</label>
											<input type="text" className="form-control" name="Viaje"
												ref={vuelo => { this.vuelo = vuelo; }}
												placeholder="No de Viaje"
												required
												defaultValue={this.state.vuelo} />
											</div>
											<div className="form-group col-md-6">
											<label className="label-bold" htmlFor="tipo">Tipo</label>
											<select name="tipo" className="form-control" onChange={this.handleChangeE} value={this.state.value}>
												<option value="pilotos"> Pilotos en Operación</option>
												<option value="pilotossap">Pilotos en Academia</option>
												<option value="tcs"> Tripulantes de Cabina en Operación</option>
												<option value="tcssap">Tripulantes de Cabina en Academia</option>
												<option value="persTierr">Personal Tierra en Operación</option>
											</select>
											</div>
											{select &&
												<div style={{width:'100%'}} className="form-row">
													<div className="form-group col-md-6">
														<label className="label-bold" htmlFor="tipo">Entrenamiento</label>
														<select name="entrenamiento" className="form-control" placeholder="Seleccione una Tipo Entrenamiento" onChange={this.handleChange} value={this.state.entrenamiento}>
															<option value="inicial">Inicial</option>
															<option value="recurrente">Recurrente</option>
														</select>
													</div>
													<div className="form-group col-md-6">
														<label className="label-bold" htmlFor="flota">Flota</label>
														<Select value={flota} placeholder="Seleccione una Flota" onChange={(e) => this.selectFlota(e)} options={flotas}/>
													</div>
												</div>
											}
										</div>
										<div className="form-row">
											<div className="form-group col-md-6">
												<label className="label-bold">Hora requerida de recogida</label>
												<TimePicker
													showSecond={false}
													defaultValue={now}
													style={{ width: '100%' }}
													onChange={this.onTimeChange.bind(this)}
													use12Hours
													inputReadOnly />
											</div>
											<div className="form-group col-md-6">
												<label className="label-bold">Hora requerida de llegada.</label>
												<TimePicker
													showSecond={false}
													defaultValue={now2}
													style={{ width: '100%' }}
													onChange={this.onTimeChange2.bind(this)}
													use12Hours
													inputReadOnly />
											</div>
										</div>
										<div className="form-row">
											<div className="col-sm-12 col-md-6">
												<label className="label-bold" htmlFor="Viaje" >Rutas</label>
												<Select placeholder='Seleccione la ruta' value={rutaA} className="css-10nd86i-2" onChange={(e) => this.selectRuta(e)} options={rutas} />
											</div>
											<div className="col-sm-12 col-md-6">
												<label className="label-bold" htmlFor="Viaje" >Centro de costos</label>
												<Select placeholder='Seleccione la ruta' value={centro} className="css-10nd86i-2" onChange={(e) => this.selectCentro(e)} options={centroCosto} />
											</div>
										</div>
										<div className="form-group col-md-4 ml-auto">
											<button type="submit" className="btn btn-green btn-mar-top float-right">Guardar</button>
										</div>
									</form>
								</div>
							</div>
						</Modal>
						<Modal isOpen={this.state.isActiveSeleccion} onRequestClose={this.toggleActiveS} style={customStylesS}>
							<div className="row" style={{ height: '100%' }}>
								<div className="col-sm-6 centro2" style={{ height: '100%' }}>
									<div className="row">
										<div className="col-sm-12 centro2">
											<div className='iconoso'></div>
										</div>
										<div className="col-sm-12 ">
											<p className='nuevoTex'>Planificación de viajes</p>
										</div>
										<div className="col-sm-12 centro2 ">
											<button onClick={() =>this.replanificar()} type="button" className="btn btn-round color1">Modificar</button>
										</div>
									</div>
								</div>
								<div className="col-sm-6 centro2" style={{ height: '100%', borderLeftWidth: 1 }}>
									<div className="row">
										<div className="col-sm-12 centro2">
											<div className='iconoso2'></div>
										</div>
										<div className="col-sm-12 ">
											<p className='nuevoTex'>Pasajeros</p>
										</div>
										<div className="col-sm-12 centro2 ">
											<button onClick={this.modificar} type="button" className="btn btn-round color1">Modificar</button>
										</div>
									</div>
								</div>
							</div>
						</Modal>
						<Modal isOpen={this.state.isActiveCarga} onRequestClose={this.toggleActiveC} style={customStylesS}>
							<CargarEmple />
						</Modal>

						<Modal isOpen={this.state.isActiveModificar} onRequestClose={this.toggleActiveM} style={customStylesM}>
							<div className="col-12">
								<div className="row">
									<img src={icon} width="17px" height="28px" />
									<div className="col">
										<h6 className="font-tex">{generales.fecha}</h6>
										<h6 className="text-color">Multi-viajeros</h6>
									</div>
									<div className="col">
										<button onClick={this.nuevoPas} className="btn btn-green-ligth float-right">+ Añadir pasajero</button>
									</div>
									<div className="col">
										{edt2.desc === 'tcs' && <button type="button" className="btn btn-green-ligth float-right">{actualV.vuelo}</button>}
										{edt2.desc === 'pilotos' && <button type="button" className="btn btn-lg-purpura float-right">{actualV.vuelo}</button>}
										{edt2.desc === 'pilotossap' && <button type="button" className="btn btn-sky-blue float-right">{actualV.vuelo}</button>}
										{edt2.desc === 'tcssap' && <button type="button" className="btn btn-sky-tsc float-right">{actualV.vuelo}</button>}

									</div>
								</div>
								<div className="row">
									<div className="col text-right">
										<p className="p-type">Hora de recogimiento: <b>{actualV.horaReco}</b></p>
										{/* <p className="p-type">Origen: <b>{inicio}</b></p>
										<p className="p-type">Desino: <b>{destino}</b></p> */}
										<p className="p-type">Estado: <b>{estado}</b></p>
									</div>
								</div>

							</div>
							<div className="row">
								<div className="col-12">
									<div className="col-sm-6 col-sm-6">
										<p className='nuevoTexRN tipoB'>¿Alguno de los pasajeros ya no abordará? <p className='alinea' onClick={this.isELi} style={{ cursor: 'pointer', color: '#42a5f5', fontFamily: 'lato' }}>Haz clic aquí.</p></p>
									</div>
									<div className="row">
										<div className="col-sm-6 col-md-6 alto">
											{this.state.viajesD.map((snap, index) => {
												return (
													<div id={index} className='empleI normalEm'>
														<div className="col-sm-9">
															<p>{snap.nombre}</p>
														</div>
														{this.state.isElimi &&
															<div className="col-sm-1">
																<a onClick={() => this.marcar(snap, index)} href="#" className=" badge badge-danger">X</a>
															</div>
														}

													</div>
												)
											})}
										</div>
										<div className="col-sm-6 col-sm-6">
											<div className="col-sm-12">
												{isGuar &&
													<Select placeholder='Seleccione empleados' onChange={this.addEmpleS} isMulti options={empleadosEmpresa} />
												}
											</div>
										</div>
									</div>
								</div>
							</div>
							{this.state.isElimi &&
								<div style={{ marginTop: 10 }} className="row">
									<div className="col-12">
										<div className="row">
											<div className="col-12 col-md-7">
												<textarea onChange={this.justi} className="form-control form-control-bg"></textarea>
											</div>
											<div className="col-12 col-md-5">
												<button onClick={this.cancela} className="btn btn-sky-blue">Continuar</button>
											</div>
										</div>
									</div>
								</div>
							}
							{this.state.isGuar &&
								<div style={{ marginTop: 10 }} className="row">
									<div className="col-12">
										<div className="row">
											<div className="col-12 col-md-7">
												<textarea onChange={this.justiA} className="form-control form-control-bg"></textarea>
											</div>
											<div className="col-12 col-md-5">
												<button onClick={this.addEmple} className="btn btn-sky-blue">Continuar</button>
											</div>
										</div>
									</div>
								</div>
							}

						</Modal>
					</div>
					<br></br>
					<footer className="footer-pg mt-auto py-3" style={{width:'100%'}}>
					<div className="container">
						<div className="row">
							<div className="col-md-4 col-sm-4">
							</div>
							<div className="col-sm">
								<img src={copyright}/>
							</div>
						</div>
					</div>
					</footer>
				</div>
			)
		}
		else {
			return (
				<Pulse />
			)
		}
	}

}
const mapStateToProps = (state)=>({
	EmpresaUID:state.nodo_empresa
});

export default connect(mapStateToProps,null)(NuevoViaje);


// WEBPACK FOOTER //
// ./src/Components/Programacion/nuevoViaje.js